import { IMG_HOST } from "./host";

export const isPrime = (number) => {
    if (number <= 1) {
        return false; // Numbers less than or equal to 1 are not prime
    }

    // Check for divisors from 2 to the square root of the number
    for (let i = 2; i <= Math.sqrt(number); i++) {
        if (number % i === 0) {
            return false; // Number is divisible by a divisor other than 1 and itself
        }
    }

    return true; // Number is prime
}

export const isOdd = (number) =>  {
    return number % 2 === 1;
}

export const getPhotoUrl = (photo, folder) => {
    if (photo === null || photo === undefined || photo === "") return null;
    if (/^https?:\/\//.test(photo)) return photo;
    return IMG_HOST + folder + "/" + photo;
}

/**
 * Safely parse a value into a finite number.
 * Replaces the legacy `eval(str)` pattern that was used to coerce form
 * input (which may contain Indonesian decimal comma, e.g. "1,5") into a
 * number. Unlike `eval`, this does not execute arbitrary JS and handles
 * null/undefined/empty/non-numeric inputs gracefully.
 *
 * Behavior:
 * - null / undefined / ''  -> 0
 * - "1.5"                 -> 1.5
 * - "1,5"                 -> 1.5  (Indonesian decimal)
 * - "abc" / "1.2.3"       -> 0
 * - 42 (number)           -> 42
 *
 * Note: the previous implementation used `String(v).split(',').join('.')`
 * which would corrupt Indonesian thousand-separator input like
 * "1.000.000,50" (it became "1.000.000.50" and parseFloat returned 1).
 * We preserve the original single-comma-decimal behavior for backwards
 * compatibility; if proper thousand-separator parsing is needed later,
 * add a second helper.
 */
export const toNum = (v) => {
    if (v === null || v === undefined || v === '') return 0;
    const normalized = String(v).split(',').join('.');
    const n = parseFloat(normalized);
    return Number.isFinite(n) ? n : 0;
};

